export default __webpack_public_path__ + "static/media/calendar-arrowL.78e27c4b.svg";